import React, { useEffect, useRef } from 'react';
import '../styles/Sector.css';

import logo from '../assets/Sectorpic.png';
import slide1 from '../assets/pic19.jpg';
import slide2 from '../assets/Pic-18.jpeg';
import slide3 from '../assets/slide3.jpg';
import slide4 from '../assets/manpower.jpg';
import slide5 from '../assets/electricaldesign.jpg';

const slideImages = [
  { src: slide1, alt: 'Slide 1' },
  { src: slide2, alt: 'Slide 2' },
  { src: slide3, alt: 'Slide 3' },
  { src: slide4, alt: 'Slide 4' },
  { src: slide5, alt: 'Slide 5' },
];

const Sector = () => {
  const numSeats = slideImages.length;
  const angleIncrement = 360 / numSeats;

  const textRef = useRef(null);
  const wheelRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-up-visible');
          observer.unobserve(entry.target); // Only once
        }
      });
    }, observerOptions);

    if (textRef.current) observer.observe(textRef.current);
    if (wheelRef.current) observer.observe(wheelRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="sector-layout">
      <div ref={textRef} className="sector-text fade-up-init">
        <h3>ELECTRICAL ENGINEERING</h3>
        <ul>
          <li>Electrical engineering is the backbone of all modern systems—power grids, telecommunications, automation, and electronics—enabling reliable energy distribution and smart technology integration in industries and daily life.</li>
          <li>It drives innovation in renewable energy, electric vehicles, and smart grids, playing a crucial role in creating sustainable and energy-efficient solutions for the future.</li>
        </ul>

        <h3>INFRASTRUCTURE</h3>
        <ul>
          <li>A strong internal infrastructure—comprising advanced tools, modern power distribution systems, and efficient logistics—ensures consistent, safe, and high-quality electrical services across all project scales.</li>
          <li>Well-established infrastructure enables the company to handle complex industrial, commercial, and residential projects efficiently, ensuring timely delivery and adherence to safety and regulatory standards.</li>
        </ul>

        <h3>OIL & GAS</h3>
        <ul>
          <li>Electrical companies provide explosion-proof installations, automation, and control systems tailored for the safety-critical conditions of oil and gas operations.</li>
          <li>By designing and maintaining high-performance power distribution and backup systems, electrical companies ensure uninterrupted operations at drilling sites, refineries, and processing plants.</li>
        </ul>
      </div>

      <div className="sector-sector-container fade-up-init" ref={wheelRef}>
        <div className="sector-logo-container">
          <img src={logo} alt="Center Logo" className="sector-center-logo" />
        </div>

        <div className="sector-ferris-wheel">
          {slideImages.map((image, index) => {
            const seatAngle = angleIncrement * index;
            const wrapperStyle = {
              transform: `rotate(${seatAngle}deg) translateY(var(--sector-wheel-radius)) rotate(-${seatAngle}deg)`,
            };

            return (
              <div
                key={index}
                className="sector-seat-wrapper"
                style={wrapperStyle}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="sector-seat-image"
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Sector;
